import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackScreenView } from "./index";

/**
 * Fires screen_view on every route change. Keyed on pathname alone — search and
 * hash both change without the user leaving the screen (the reports list writes
 * the selected report into location.hash on every card click).
 */
const useScreenTracking = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    trackScreenView(pathname);
  }, [pathname]);
};

export default useScreenTracking;
